<template>
  <div>
    Checking licenses
  </div>
</template>


<script>
import ContractTypeConstants from "@/helpers/Constants/ContractTypeConstants";
import LicenseKeys from "@/helpers/Constants/LicenseKeys";

export default {
  name: "Contracts",
  props: [],
  components: {},
  mixins: [],

  data() {
    return {};
  },

  mounted() {
    this.redirect();
  },

  methods: {
    redirect() {
      //if licenced to contracts land on next orders
      if (this.hasContractLicense) {
        this.$router.replace({ name: 'NextOrders' });
      }
      //redir to quotation list if no contract license
      else if (this.hasQuotationLicense) {
        this.$router.replace({
          name: 'Contracts',
          params: {
            contractTypeId: ContractTypeConstants.ids.Quotation
          }
        });
      }
      //just redir to dashboard if no license at all
      else {
        this.$router.replace({ name: 'DashboardHome' });
      }
    },
  },

  computed: {
    hasContractLicense() {
      return this.checkIfLicencedByKey(LicenseKeys.Contract);
    },
    hasQuotationLicense() {
      return this.checkIfLicencedByKey(LicenseKeys.Quotation);
    },
  },

  watch: {
    "$route.name"() {
      this.redirect();
    },
  },
};
</script>

<style lang="scss" scoped></style>